export class AddSubtopicErrorResponse {
  subtopicHeader: any;
}
